export default {
  getLoadingApp(state) {
    return state.loadingapp;
  },
  getPrintMode(state) {
    return state.printmode;
  },
  getLongLoader(state) {
    return state.longloader;
  },
  getLongLoaderMessage(state) {
    return state.longloader.message;
  },
  getErrorMessage(state) {
    return state.errormessage;
  },
  getInfoMessage(state) {
    return state.infomessage;
  },
  getWarningMessage(state) {
    return state.warningmessage !== undefined ? state.warningmessage.data : null;
  },
  getWarningDevice(state) {
    return state.warningmessage !== undefined ? state.warningmessage.deviceId : null;
  },

  getLoggedIn(state) {
    return state.user !== undefined;
  },
  getLoggedInUser(state) {
    return state.user;
  },
  getLanguages(state) {
    return state.languages
  },
  getAzureMapKey(state) {
    return state.azureMapKey
  },

  getDevices(state) {
    return state.devices
  },
  getCurrentDevice(state) {
    return state.currentDevice
  },
  getCurrentDeviceHistoricalData(state) {
    return state.currentDeviceHistoricalData
  },
  getCurrentDeviceAlarmData(state) {
    return state.currentDeviceAlarmData
  },
  getKpi(state) {
    return state.kpis
  },
  getCurrentDevicePir(state) {
    return state.currentDevicePir
  },

  getDevicesUsers(state) {
    return state.userSignalR.devices
  },

  getAdminTranslations(state) {
    return state.admin.translations || [];
  },
  getAdminUsers(state) {
    return state.admin.users || [];
  },
  getAdminContacts(state) {
    return state.admin.contacts || [];
  },
}
